import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AgentsQueryKeys } from "@/tanstackQuery/queries/agents";
import { updateAgentBalance } from "@/api/agents";
export const useUpdateAgentBalance = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAgentBalance,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [AgentsQueryKeys.All],
      });
    },
  });
};
